import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import WSButton from "../../../Components/Button/WSButton";
import WSTextField from "../../../Components/TextBox/WSTextBox";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { updateMainHeader } from "../../../commonFunctions/CommonFunctions";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";

export const Category: React.FC<any> = React.memo((props) => {
  const { control, register, handleSubmit, setValue, reset } = useForm();
  const [loadingSaveAndNew, setLoadingSaveAndNew] = useState(false);
  const [loading, setLoading] = useState(false);
  const params = useParams();
  const id = params?.id;
  const navigate = useNavigate();
  useEffect(() => {
    updateMainHeader("Category");
  });

  breadCrumbsStore.updateBreadCrumbs([
    { "Category List": "/category/list" },
    { [!id ? "Add Category" : "Update Category"]: "/category/create" },
  ]);
  const handleCancelClick = () => {
    navigate("/category/list");
  };

  const handleData = async (data: any) => {
    debugger;
    console.log("onsubmit===>", data); // You can perform any action with the submitted data here
  };

  const handleDataSaveAndNew = () => {};

  return (
    <>
      <Grid p={3}>
        <form onSubmit={handleSubmit(handleData)}>
          <Grid
            sx={{
              padding: 4,
              backgroundColor: "#fff",
              borderRadius: 2,
              border: "1px solid lightgrey",
              marginTop: 3,
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <WSTextField
                  label={"Category Name"}
                  {...register("name")}
                  id="name"
                  name="name"
                  control={control}
                  rules={{ required: true }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid container justifyContent="flex-end" spacing={2} sx={{ mt: 2 }}>
            <Grid item>
              <WSButton
                id="cancel"
                type="button"
                label="Cancel"
                size="medium"
                onClick={handleCancelClick}
                variant="outlined"
                color="primary"
                sx={{
                  borderRadius: 8,
                  width: "8rem",
                  border: "1px solid #098963",
                  color: "#098963",
                  backgroundColor: "#FFFFFF",
                }}
              />
            </Grid>
            <Grid item>
              <WSButton
                id="submit"
                type="submit"
                label="Save & New"
                size="medium"
                variant="outlined"
                color="primary"
                onClick={handleSubmit(handleDataSaveAndNew)}
                loading={loadingSaveAndNew}
                sx={{
                  borderRadius: 8,
                  width: "8rem",
                  border: "1px solid #098963",
                  color: "#FFFFFF",
                  backgroundColor: "#098963",
                  "&:hover": {
                    backgroundColor: "#066e4f",
                  },
                }}
              />
            </Grid>

            <Grid item>
              <WSButton
                id="submit"
                type="submit"
                label="Save"
                size="medium"
                variant="outlined"
                color="primary"
                loading={loading}
                onClick={handleSubmit(handleData)}
                sx={{
                  borderRadius: 8,
                  width: "8rem",
                  border: "1px solid #098963",
                  color: "#FFFFFF",
                  backgroundColor: "#098963",
                  "&:hover": {
                    backgroundColor: "#066e4f",
                  },
                }}
              />
            </Grid>
          </Grid>
        </form>
      </Grid>
    </>
  );
});
